import React, {Component} from 'react'
import moment from 'moment';
import 'moment/locale/zh-cn';
import KtDeliveryStep from '../../components/step/kt-delivery-step'
import {
    Table,
    Row,
    Col,
    Button,
    Input,
    message,
    Popconfirm,
    InputNumber,
    Form,
    DatePicker,
    AutoComplete,
    Tabs, Timeline, Upload, Select
} from 'antd'
import '../track-info/track.less'
import axios from 'axios'
import {getKtOrderTrails, getKtCabinShort, reqDeviceList, ktSquadNo, getKtOrderDelivery, baseUrl} from '../../api'
import authorizeBase from "../../components/authorize/authorizeBase";
import authorize from "../../components/authorize/authorize";
import {ReactBingmaps} from "react-bingmaps";
import ajax from "../../api/ajax";
import RouteStepViewForm from "../route/route-step-view";
import KtTrackLocTableForm from "./kt-track-loc-table";
const AuthButton = authorizeBase(Button);
moment.locale('zh-cn');
const PAGE_SIZE = 10;
const {Option} = Select;

const {TextArea} = Input;
const {TabPane} = Tabs;
const SYS = "mms";
let orderId = '';
const EditableContext = React.createContext();
class ComA extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (<a {...this.props}></a>)
    }
}
const AuthA = authorizeBase(ComA);
class EditableCell extends React.Component {
    state = {
        autoDataSource: [],
        pageNum: 1,
        pageSize: 10000
    };
    getInput = (dataIndex) => {
        const {boxNoData} = this.props;
        const {autoDataSource} = this.state
        if (this.props.inputType === 'number') {
            return <InputNumber />;
        } else if (this.props.inputType === 'date') {
            return <DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>;
        } else if (this.props.inputType === 'date2') {
            return <DatePicker format="YYYY-MM-DD"/>;
        } else if (this.props.inputType === 'select'
            && dataIndex === 'boxNo') {
            return <Select style={{width: 150}}>
                {boxNoData.map(item => (
                    <Option key={item.boxNo} value={item.boxNo}>{item.boxNo}</Option>
                ))}
            </Select>;
        } else if (this.props.inputType === 'auto') {
            return <AutoComplete
                dataSource={autoDataSource}
                style={{width: 200}}
                onSearch={this.onChange}
                onSelect={this.onSelect}
                onFocus={this.onFocus}
            />;
        }
        return <Input />;
    };

    onFocus = value => {
        this.getProducts(value)
    };

    onChange = value => {
        this.getProducts(value)
    };
    getProducts = async (deviceId) => {
        const {pageNum, pageSize} = this.state
        const values = {}
        values.deviceId = deviceId;
        values.pageNum = pageNum;
        values.pageSize = pageSize;
        let result = await reqDeviceList(values)
        if (result.code === 200) {
            let res = result.data.rows;
            if (res && res.length > 0) {
                res = res.map((obj) => {
                    return obj.deviceId
                });
                this.setState({
                    autoDataSource: res
                })
            } else {
                this.setState({
                    autoDataSource: []
                })
            }
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {

        }

    };

    getInitValue = (record, dataIndex) => {
        if (this.props.inputType === 'date' && record[dataIndex]) {
            return moment(record[dataIndex], 'YYYY-MM-DD HH:mm:ss');
        } else if (this.props.inputType === 'date2' && record[dataIndex]) {
            return moment(record[dataIndex], 'YYYY-MM-DD');
        }
        return record[dataIndex];
    };

    renderCell = ({getFieldDecorator}) => {
        const {
            editing,
            dataIndex,
            title,
            record,
            children,
            ...restProps
        } = this.props;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item style={{margin: 0}}>
                        {getFieldDecorator(dataIndex, {
                            rules: [
                                {
                                    required: (dataIndex == 'optDt' || dataIndex == 'note' || dataIndex == 'truckNo' || (dataIndex == 'boxNo' && this.props.inputType != 'select')) ? true : false,
                                    message: `请填写 ${title}!`,
                                },
                                {
                                    len: (dataIndex == 'boxNo') ? 11 : '',
                                    message: `${title}为11位!`,
                                },
                            ],
                            initialValue: this.getInitValue(record, dataIndex),
                        })(this.getInput(dataIndex))}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };

    render() {
        return <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>;
    }
}

class TrackInfo extends Component {
    constructor(props) {
        super(props)
        this.columns = [
            {
                title: '序号',
                dataIndex: '',
                render: (text, record, index) => `${index+1+PAGE_SIZE*(this.state.wuliuPageNum-1)}`,
            },
            {
                title: '集装箱号',
                dataIndex: 'boxNo',
                editable: true,
            },
            {
                title: '厂封号',
                dataIndex: 'factoryNo',
                editable: true,
            },
            {
                title: '铁路封号',
                dataIndex: 'trainNo',
                editable: true,
            },
            {
                title: '运单批号',
                dataIndex: 'deliveryNo',
                editable: true,
            },
            {
                title: '装箱地点',
                dataIndex: 'boxLocation',
                editable: true,
            },
            {
                title: 'GPS编号',
                dataIndex: 'trailNo',
                key: 'trailNo',
                editable: true,
            }, {
                title: '操作',
                dataIndex: 'opt',
                render: (text, record) => {
                    const {editingKey, dataSource} = this.state;
                    const editable = this.isEditing(record);

                    return editable ? (
                        <span>
                          <EditableContext.Consumer>
                            {form => (
                                <AuthA authority="delivery_edit:delivery_save"
                                       onClick={() => this.save(form, record.key)}
                                       style={{marginRight: 8}}
                                >
                                    保存
                                </AuthA>
                            )}
                          </EditableContext.Consumer>
                          <Popconfirm title="是否确定取消?" onConfirm={() => this.cancel(record.key)}>
                            <a>取消</a>
                          </Popconfirm>
                        </span>
                    ) : (
                        <span> <AuthA authority="delivery_edit:delivery_save" disabled={editingKey !== ''}
                                      onClick={() => this.edit(record.key)}
                                      style={{marginRight: 8}}>
                                        修改
                                    </AuthA>
                            <Popconfirm title="是否确定删除?" onConfirm={() => this.handleDelete(record.key)}>
                            <AuthA authority="delivery_edit:delivery_delete">删除</AuthA>
                        </Popconfirm>
                        </span>
                    );
                }
            }
        ];
        this.noteColumns = [
            {
                title: '序号',
                dataIndex: '',
                render: (text, record, index) => (
                    <span>{index + 1 + (this.state.page - 1) * this.state.pageSize}</span>
                )
            },
            {
                title: '日期',
                dataIndex: 'optDt',
                editable: true,
            },
            {
                title: '备注说明',
                width: '100',
                dataIndex: 'note',
                editable: true,
            }, {
                title: '操作',
                fixed: 'right',
                width: 100,
                dataIndex: 'opt',
                render: (text, record) => {
                    const {noteEditingKey, noteDataSource} = this.state;
                    const editable = this.isEditingNote(record);

                    return editable ? (
                        <span>
                          <EditableContext.Consumer>
                            {form => (
                                <AuthA authority="delivery_edit:note_save"
                                       onClick={() => this.saveNote(form, record.key)}
                                       style={{marginRight: 8}}
                                >
                                    保存
                                </AuthA>
                            )}
                          </EditableContext.Consumer>
                          <Popconfirm title="是否确定取消?" onConfirm={() => this.cancelNote(record.key)}>
                            <a>取消</a>
                          </Popconfirm>
                        </span>
                    ) : (
                        <span> <AuthA authority="delivery_edit:note_save" disabled={noteEditingKey !== ''}
                                      onClick={() => this.editNote(record.key)}
                                      style={{marginRight: 8}}>
                                        修改
                                    </AuthA>
                            <Popconfirm title="是否确定删除?" onConfirm={() => this.handleDeleteNote(record.key)}>
                            <AuthA authority="delivery_edit:note_delete">删除</AuthA>
                        </Popconfirm>
                        </span>
                    );
                }
            }
        ];

        this.vehicleColumns = [
            {
                title: '序号',
                dataIndex: '',
                render: (text, record, index) => (
                    <span>{index + 1 + (this.state.page2 - 1) * this.state.pageSize2}</span>
                )
            },
            {
                title: '车牌号',
                dataIndex: 'truckNo',
                editable: true,
            },
            {
                title: '司机姓名',
                width: '100',
                dataIndex: 'name',
                editable: true,
            },
            {
                title: '身份证号码',
                width: '100',
                dataIndex: 'identification',
                editable: true,
            },
            {
                title: '手机号码',
                width: '100',
                dataIndex: 'phone',
                editable: true,
            }, {
                title: '集装箱号',
                dataIndex: 'boxNo',
                width: 100,
                editable: true,
            }, {
                title: '操作',
                fixed: 'right',
                width: 100,
                dataIndex: 'opt',
                render: (text, record) => {
                    const {vehicleEditingKey, vehicleDataSource} = this.state;
                    const editable = this.isEditingVehicle(record);
                    return editable ? (
                        <span>
                          <EditableContext.Consumer>
                            {form => (
                                <AuthA authority="delivery_edit:car_save"
                                       onClick={() => this.saveVehicle(form, record.key)}
                                       style={{marginRight: 8}}
                                >
                                    保存
                                </AuthA>
                            )}
                          </EditableContext.Consumer>
                          <Popconfirm title="是否确定取消?" onConfirm={() => this.cancelVehicle(record.key)}>
                            <a>取消</a>
                          </Popconfirm>
                        </span>
                    ) : (
                        <span> <AuthA authority="delivery_edit:car_save" disabled={vehicleEditingKey !== ''}
                                      onClick={() => this.editVehicle(record.key)}
                                      style={{marginRight: 8}}>
                                        修改
                                    </AuthA>
                            <Popconfirm title="是否确定删除?" onConfirm={() => this.handleDeleteVehicle(record.key)}>
                            <AuthA authority="delivery_edit:car_delete">删除</AuthA>
                        </Popconfirm>
                        </span>
                    );
                }
            }
        ];

        this.state = {
            originAdd: '',
            destinaAdd: '',
            otherExplain: '',
            deliveryDt: '',
            dataSource: [],
            count: 0,
            editingKey: '',
            dataSource2: [],
            editingKey2: '',
            destinationCity: '',
            noteEditingKey: '',
            noteDataSource: [],
            page: 1,
            pageSize: 10,
            noteCount: 0,
            total: 0,
            vehicleEditingKey: '',
            vehicleDataSource: [],
            page2: 1,
            pageSize2: 10,
            vehicleCount: 0,
            total2: 0,
            stepEditable: true,
            autoAllData: [],
            bingmapKey: "AuXjIRtmvSChnWxFOVerDnOU8EZyQ-LXI-w9zsxkmEYFR9DmScWoZFM88YcTw6uv",
            center: [],
            rowId: 1,
            mapData: [],
            stepDescription: [],
            currentTrailNo: '',
            orderNodes: [],
            routeType: [],
            loading: false,
            orderId: "",
            boxNoData: [],
            wuliuPageNum:1,
        }
    }

    isEditing = record => record.key === this.state.editingKey;
    cancel = () => {
        this.setState({editingKey: ''});
    };

    handleDelete = key => {
        const dataSource = [...this.state.dataSource];
        const index = dataSource.findIndex(item => key === item.key);
        const item = dataSource[index];
        if (item && item.id) {
            let id = item.id;
            axios.delete(baseUrl + '/api/v1/p/mms/ktDeliveryDel', {params: {id}}).then((res) => {
                var result = res.data;
                if (result.code === 200) {
                    this.setState({dataSource: dataSource.filter(item => item.key !== key)});
                    message.success(result.message);
                } else {
                    message.error(result.message)
                    return false;
                }
            })
        } else {
            this.setState({dataSource: dataSource.filter(item => item.key !== key)});
        }
    };

    getAllProducts = async (deviceId) => {
        const values = {};
        values.deviceId = deviceId;
        values.pageNum = 1;
        values.pageSize = 10000;
        let result = await reqDeviceList(values);
        if (result.code === 200) {
            let res = result.data.rows;
            if (res && res.length > 0) {
                this.setState({
                    autoAllData: res
                })
            } else {
                this.setState({
                    autoAllData: []
                })
            }
        }
    };

    save(form, key) {
        form.validateFields((error, row) => {
            if (error) {
                return;
            }
            const {autoAllData} = this.state;
            const trailNo = row.trailNo;

            const filterData = autoAllData.filter(item => item.deviceId === trailNo)
            if (true/*filterData && filterData.length > 0*/) {
                const newData = [...this.state.dataSource];
                const index = newData.findIndex(item => key === item.key);
                if (index > -1) {
                    const item = newData[index];
                    row.orderid = orderId;
                    row.id = item.id;
                    if (row && row.id) {
                        axios.put(baseUrl + '/api/v1/p/mms/ktDeliveryUpdate', row).then((res) => {
                            newData.splice(index, 1, {
                                ...item,
                                ...row,
                            });

                            var result = res.data;
                            if (result.code === 200) {
                                this.setState({dataSource: newData, editingKey: ''});
                                message.success(result.message);
                            } else {
                                message.error(result.message)
                                return false;
                            }
                        })
                    } else {
                        axios.post(baseUrl + '/api/v1/p/mms/ktDeliverySave', row).then((res) => {
                            var result = res.data;
                            if (result.code === 201) {
                                row.id = result.data.id;
                                newData.splice(index, 1, {
                                    ...item,
                                    ...row,
                                });
                                this.setState({dataSource: newData, editingKey: ''});
                                message.success(result.message);
                            } else {
                                message.error(result.message);
                                return false;
                            }
                        })
                    }
                } else {
                    newData.push(row);
                    this.setState({dataSource: newData, editingKey: ''});
                }
            } else {
                message.error('请选择存在的GPS编号')
            }


        });
    }

    edit(key) {
        this.setState({editingKey: key});
    }

    handleAdd = () => {
        const {count, dataSource} = this.state;
        const newData = {
            key: count,
            deliveryNo: '',
            boxNo: '',
            trailNo: '',
        };
        this.setState({
            dataSource: [...dataSource, newData],
            count: count + 1,
        });
    };

    //第二张表格
    isEditing2 = record => record.key === this.state.editingKey2;
    cancel2 = () => {
        this.setState({editingKey2: ''});
    };

    save2(form, key) {
        form.validateFields((error, row) => {
            if (error) {
                return;
            }
            const newData = [...this.state.dataSource2];
            const index = newData.findIndex(item => key === item.key);
            if (index > -1) {
                row.optDt = moment(row.optDt).format('YYYY-MM-DD HH:mm:ss');
                const item = newData[index];

                row.orderId = orderId;
                row.id = item.id;
                row.optType = item.optType;
                if (row && row.id) {
                    newData.splice(index, 1, {
                        ...item,
                        ...row,
                    });
                    axios.put(baseUrl + '/api/v1/p/mms/ktRecordUpdate', row).then((res) => {
                        var result = res.data;
                        if (result.code === 200) {
                            this.setState({dataSource2: newData, editingKey2: ''});
                            message.success(result.message);
                        } else {
                            message.error(result.message);
                            return false;
                        }
                    })
                } else {
                    axios.post(baseUrl + '/api/v1/p/mms/ktRecordSave', row).then((res) => {
                        var result = res.data;
                        if (result.code === 201) {
                            row.id = result.data.id;
                            newData.splice(index, 1, {
                                ...item,
                                ...row,
                            });
                            this.setState({dataSource2: newData, editingKey2: ''});
                            message.success(result.message);
                        } else {
                            message.error(result.message);
                            return false;
                        }
                    })
                }
            } else {
                newData.push(row);
                this.setState({dataSource: newData, editingKey: ''});
            }
        });
    }

    isEditingNote = record => record.key === this.state.noteEditingKey;
    cancelNote = () => {
        this.setState({noteEditingKey: ''});
    };

    isEditingVehicle = record => record.key === this.state.vehicleEditingKey;
    cancelVehicle = () => {
        this.setState({vehicleEditingKey: ''});
    };

    handleDeleteNote = key => {
        const dataSource = [...this.state.noteDataSource];
        const index = dataSource.findIndex(item => key === item.key);
        const item = dataSource[index];
        const dataSourceLength = dataSource.length - 1;
        const {page, pageSize} = this.state;
        if (item && item.id) {
            let id = item.id;
            axios.delete(baseUrl + '/api/v1/p/mms/ktOrderNote', {params: {id}}).then((res) => {
                var result = res.data;
                if (result.code === 200) {
                    const dataLength = dataSourceLength % pageSize
                    if (dataLength === 0) {
                        const totalPage = dataSourceLength / pageSize
                        if (totalPage <= page && page != 1) {
                            this.setState({
                                page: totalPage
                            })
                        }
                    }
                    this.setState({noteDataSource: dataSource.filter(item => item.key !== key)});
                    message.success(result.message);
                } else {
                    message.error(result.message)
                    return false;
                }
            })
        } else {
            const dataLength = dataSourceLength % pageSize
            if (dataLength === 0) {
                const totalPage = dataSourceLength / pageSize
                if (totalPage <= page && page != 1) {
                    this.setState({
                        page: totalPage
                    })
                }
            }
            this.setState({noteDataSource: dataSource.filter(item => item.key !== key)});
        }
    };

    handleDeleteVehicle = key => {
        const dataSource = [...this.state.vehicleDataSource];
        const index = dataSource.findIndex(item => key === item.key);
        const item = dataSource[index];
        const dataSourceLength = dataSource.length - 1;
        const {page2, pageSize2} = this.state;
        if (item && item.id) {
            let id = item.id;
            axios.delete(baseUrl + '/api/v1/p/mms/ktOrderVehicleDel', {params: {id}}).then((res) => {
                // debugger
                var result = res.data;
                if (result.code === 200) {
                    const dataLength = dataSourceLength % pageSize2;
                    if (dataLength === 0) {
                        const totalPage2 = dataSourceLength / pageSize2;
                        if (totalPage2 <= page2 && page2 != 1) {
                            this.setState({
                                page: totalPage2
                            })
                        }
                    }
                    this.setState({vehicleDataSource: dataSource.filter(item => item.key !== key)});
                    message.success(result.message);
                } else {
                    message.error(result.message)
                    return false;
                }
            })
        } else {
            const dataLength = dataSourceLength % pageSize2;
            if (dataLength === 0) {
                const totalPage2 = dataSourceLength / pageSize2;
                if (totalPage2 <= page2 && page2 != 1) {
                    this.setState({
                        page2: totalPage2
                    })
                }
            }
            this.setState({vehicleDataSource: dataSource.filter(item => item.key !== key)});
        }
    };

    saveNote(form, key) {
        form.validateFields((error, row) => {
            if (error) {
                return;
            }
            const newData = [...this.state.noteDataSource];
            const index = newData.findIndex(item => key === item.key);
            if (index > -1) {
                const item = newData[index];
                row.orderId = orderId;
                row.id = item.id;
                row.optDt = moment(row.optDt).format('YYYY-MM-DD');
                if (row && row.id) {
                    axios.put(baseUrl + '/api/v1/p/mms/ktOrderNote', row).then((res) => {
                        newData.splice(index, 1, {
                            ...item,
                            ...row,
                        });
                        var result = res.data;
                        if (result.code === 200) {
                            this.setState({noteDataSource: newData, noteEditingKey: ''});
                            message.success(result.message);
                        } else {
                            message.error(result.message)
                            return false;
                        }
                    })
                } else {
                    axios.post(baseUrl + '/api/v1/p/mms/ktOrderNote', row).then((res) => {
                        var result = res.data;
                        if (result.code === 201) {
                            row.id = result.data.id;
                            newData.splice(index, 1, {
                                ...item,
                                ...row,
                            });
                            this.setState({noteDataSource: newData, noteEditingKey: ''});
                            message.success(result.message);
                        } else {
                            message.error(result.message)
                            return false;
                        }
                    })
                }
            } else {
                newData.push(row);
                this.setState({noteDataSource: newData, noteEditingKey: ''});
            }
        });
    }

    saveVehicle(form, key) {
        form.validateFields((error, row) => {
            if (error) {
                return;
            }
            const newData = [...this.state.vehicleDataSource];
            const index = newData.findIndex(item => key === item.key);
            if (index > -1) {
                const item = newData[index];
                row.orderId = orderId;
                row.id = item.id;
                if (row && row.id) {
                    axios.put(baseUrl + '/api/v1/p/mms/ktOrderVehicleUpdate', row).then((res) => {
                        newData.splice(index, 1, {
                            ...item,
                            ...row,
                        });
                        var result = res.data;
                        if (result.code === 200) {
                            this.setState({vehicleDataSource: newData, vehicleEditingKey: ''});
                            message.success(result.message);
                        } else {
                            message.error(result.message);
                            return false;
                        }
                    })
                } else {
                    axios.post(baseUrl + '/api/v1/p/mms/ktOrderVehicleSave', row).then((res) => {
                        var result = res.data;
                        if (result.code === 201) {
                            row.id = result.data.id;
                            newData.splice(index, 1, {
                                ...item,
                                ...row,
                            });
                            this.setState({vehicleDataSource: newData, vehicleEditingKey: ''});
                            message.success(result.message);
                        } else {
                            message.error(result.message);
                            return false;
                        }
                    })
                }
            } else {
                newData.push(row);
                this.setState({vehicleDataSource: newData, vehicleEditingKey: ''});
            }
        });
    }

    editNote(key) {
        this.setState({noteEditingKey: key});
    }

    getBoxNos = async (orderId) => {
        let result = await getKtOrderDelivery(orderId)
        if (result.code === 200) {
            let res = result.data;
            if (res && res.length > 0) {
                this.setState({
                    boxNoData: res
                })
            } else {
                this.setState({
                    boxNoData: []
                })
            }
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {

        }

    }

    editVehicle(key) {
        this.getBoxNos(orderId);
        this.setState({vehicleEditingKey: key});
    }


    handleAddNote = () => {
        const {noteCount, noteDataSource} = this.state;
        const newData = {
            key: noteCount,
            noteOptDt: null,
            note: ''
        };
        const datasource = [];
        datasource.push(newData);
        noteDataSource.forEach(function (item) {
            datasource.push(item)
        });
        this.setState({
            noteDataSource: datasource,
            noteCount: noteCount + 1,
        });
    };

    handleAddVehicle = () => {
        const {vehicleCount, vehicleDataSource} = this.state;
        const newData = {
            key: vehicleCount,
            truckNo: '',
            name: '',
            identification: '',
            phone: ''
        };
        const datasource = [];
        vehicleDataSource.forEach(function (item) {
            datasource.push(item)
        });
        datasource.push(newData)
        this.setState({
            vehicleDataSource: datasource,
            vehicleCount: vehicleCount + 1,
        });
    };

    getNotes = (pageNum) => {
        this.setState({
            page: pageNum,// 保存pageNum, 让其它方法可以看到
            pageSize: 10
        });

        axios.get(baseUrl + '/api/v1/p/mms/ktOrderNoteList', { // 配置对象
            params: {orderId: orderId, pageNum: this.state.page, pageSize: 10000} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                // debugger
                if (result.data && result.data.rows && result.data.rows.length > 0) {
                    const data = [];
                    for (let i = 0; i < result.data.rows.length; i++) {
                        result.data.rows[i].key = i;
                        result.data.rows[i].optDt = (result.data.rows[i].optDt ? result.data.rows[i].optDt.substr(0, 10) : '')
                        data.push(result.data.rows[i]);
                    }
                    this.setState({
                        total: result.data.total,
                        noteDataSource: data,
                        noteCount: result.data.total
                    })
                }
            } else {
                message.error(result.message);
                return false;
            }
        });

    };

    getVehicle = (pageNum) => {
        this.setState({
            page: pageNum,// 保存pageNum, 让其它方法可以看到
            pageSize: 10
        });

        axios.get(baseUrl + '/api/v1/p/mms/ktOrderVehicleList', { // 配置对象
            params: {orderId: orderId, pageNum: this.state.page2, pageSize: 10000} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                if (result.data && result.data.rows && result.data.rows.length > 0) {
                    const data = [];
                    for (let i = 0; i < result.data.rows.length; i++) {
                        result.data.rows[i].key = i;
                        data.push(result.data.rows[i]);
                    }
                    this.setState({
                        total2: result.data.total,
                        vehicleDataSource: data,
                        vehicleCount: result.data.total
                    })
                }
            } else {
                message.error(result.message);
                return false;
            }
        });

    };
    getOrderNodes = async (orderId) => {
        this.setState({
            loading: true,
        })
        let result = await ajax(baseUrl + "/api/v1/p/mms/kt/orderNodes", {orderId});
        if (result && result.data) {
            let nodes = [];
            if (nodes) {
                nodes = result.data.nodeVos.sort((a, b) => {
                    return a.indx - b.indx
                })
            }
            this.setState({
                orderNodes: nodes,
                routeType: result.data.type,
            })
        } else {
            message.error("轨迹信息不存在！")
        }
        this.setState({
            loading: false
        })
    }

    componentDidMount() {
        this.getAllProducts('');
        authorize("delivery_edit:trail_edit").then(() => {
            this.setState({
                stepEditable: true
            })
        }).catch(() => {
            this.setState({
                stepEditable: false
            })
        });

        orderId = this.props.location.state.orderId;
        this.setState({
            orderId
        })


        this.getKtCabinShortFunc(orderId);
        this.getKtOrderDelivery(orderId);
        this.getNotes(1);
        this.getVehicle(1);
        this.getOrderNodes(orderId)
    }

    getKtCabinShortFunc = async (id) => {
        let result = await getKtCabinShort(id)
        if (result.code === 200) {
            var data = result.data;
            data.start = data.originCountry + (data.originProvince ? data.originProvince : '') + data.originCity;
            data.destination = data.destinationCountry + (data.destinationProvince ? data.destinationProvince : '') + data.destinationCity;
            const originAdd = data.originCountry + ' ' + data.originCity
            const destinaAdd = data.destinationCountry + ' ' + data.destinationCity
            const otherExplain = data.otherExplain
            this.setState({
                ...data,
                destinationCity: data.destinationCity,
                originAdd,
                destinaAdd,
                otherExplain
            });
            const {dataSource2} = this.state;
            if (dataSource2 && dataSource2.length == 6) {
                var row = {
                    name: '到达' + data.destinationCity
                };
                const newData = [...this.state.dataSource2];
                const index = newData.findIndex(item => "5" === item.key);
                if (index > -1) {
                    const item = newData[index];
                    newData.splice(index, 1, {
                        ...item,
                        ...row,
                    });
                }
                this.setState({dataSource2: newData});
            }
        } else {
            message.error(result.message)
        }
    };
    getKtOrderDelivery = (orderId) => {
        axios.get(baseUrl + '/api/v1/p/mms/ktOrderDelivery', { // 配置对象
            params: {orderId} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                if (result.data && result.data.length > 0) {
                    const data = [];
                    for (let i = 0; i < result.data.length; i++) {
                        result.data[i].key = i;
                        data.push(result.data[i]);
                    }
                    this.setState({
                        dataSource: data,
                        count: result.data.length,
                        mapData: result.data,
                        center: [],
                        infoboxesWithPushPins: [],
                        polyline: {"location": [], "option": {strokeColor: '', strokeThickness: 0}},
                    });
                    this.timer_two(data[0].trailNo);
                    this.getRightOrderTrails(data[0].trailNo)
                    this.setState({currentTrailNo: data[0].trailNo})
                }
            } else {
                message.error(result.message)
                return false;
            }
        });
    }


    setColletDt = (date) => {
        if (date) {
            this.setState({
                deliveryDt: date
            })
        }

    };

    saveExplain = (data) => {
        axios.put(baseUrl + '/api/v1/p/mms/ktOrderExplainSave', data).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                message.success(result.message);
            } else {
                message.error(result.message);
                return false;
            }
        })
    };
    handleSaveSubmit = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            const {tableData} = this.state
            if (err) {
                return;
            } else {
                values.id = orderId;
                this.saveExplain(values);
            }
        });
    };
    timer_two = (record) => setTimeout(
        () => {
            this.getKtOrderTrails(record)
        },
        2000
    )
    getRightOrderTrails = async (trailNo) => {
        if (trailNo) {
            let result = await getKtOrderTrails({trailNo, type: 'all', orderId})
            if (result.code === 200 && result.data.length > 0) {
                let description = [];
                result.data.forEach(function (item) {
                    let sesObj = {
                        id: item.id,
                        sts: item.sts,
                        activeDt: item.activeDt,
                        address: item.address,
                        latitude: item.latitude,
                        longitude: item.longitude,
                        uTemperature: item.uTemperature,
                        uSignalstrength: item.uSignalstrength

                    };
                    description.push(sesObj)
                });
                this.setState({
                    stepDescription: description
                });
            } else if (result.code === 200) {
                this.setState({
                    stepDescription: []
                });
            } else {
                message.error(result.message)
            }
        }
    };
    getKtOrderTrails = async (trailNo) => {
        if (trailNo) {
            let result = await getKtOrderTrails({trailNo, type: 'normal', orderId})
            if (result.code === 200 && result.data.length > 0) {
                let ret = [];
                let ret2 = [];
                result.data.forEach((item) => {
                    let address =
                        '位置:' + item.address + '<br/>' +
                        '设备号:' + item.trailNo + '<br/>' +
                        '到达时间:' + item.activeDt + '<br/>' +
                        '经度:' + item.longitude + '<br/>' +
                        '纬度:' + item.latitude + '<br/>' +
                        '温度(摄氏):' + item.uTemperature + '<br/>' +
                        '电量(%):' + item.uBattery + '<br/>' +
                        '信号强度:' + item.uSignalstrength;
                    ret.push({
                        "location": [item.latitude, item.longitude],
                        "addHandler": "mouseover",
                        "infoboxOption": {title: "", description: address, maxHeight: 300, maxWidth: 420},
                        "pushPinOption": {title: "", description: "", color: 'DodgerBlue'},
                        "infoboxAddHandler": {
                            "type": "click", callback: () => {
                                this.scrollInto("step" + item.id)
                            }
                        },
                        "pushPinAddHandler": {
                            "type": "click", callback: () => {
                                this.scrollInto("step" + item.id)
                            }
                        }
                    });
                    ret2.push([item.latitude, item.longitude])
                });

                this.setState({
                    center: ret2[0],
                    infoboxesWithPushPins: ret,
                    polyline: {"location": ret2, "option": {strokeColor: 'DodgerBlue', strokeThickness: 4}},
                });
            } else if (result.code === 200) {
                this.setState({
                    center: [],
                    infoboxesWithPushPins: [],
                    polyline: {"location": [], "option": {strokeColor: '', strokeThickness: 0}},
                });
            } else {
                message.error(result.message)
            }
        }
    };
    tabChange = (key) => {
        if(key==""||key==null||key==undefined||key=='null'){
            message.info("没有绑定GPS设备!")
            return
        }
        this.getKtOrderTrails(key)
        this.getRightOrderTrails(key)
        this.setState({currentTrailNo: key})
    };
    steDescription = (obj) => {
        if (obj) {
            return <div>
                <div>{obj.activeDt}</div>
                <div>{obj.address}</div>
                <div>经度:{obj.longitude}</div>
                <div>纬度:{obj.latitude}</div>
                <div>温度(摄氏):{obj.uTemperature}</div>
                <div>信号强度:{obj.uSignalstrength}</div>
            </div>
        }

    };

    scrollInto = (id) => {
        let anchorElement = document.getElementById(id);
        if (anchorElement) {
            this.setState({
                activeId: id,
            });
            anchorElement.scrollIntoView({block: "start", inline: "start"});
        } else {
            console.log(id + " not found")
        }
    };
    saveSquadNumber = async () => {
        const {id, squadNumber} = this.state;
        const result = await ktSquadNo({orderId: id, squadNumber});
        if (result.code === 200) {
            message.info(result.message)
        } else {
            message.error(result.message)
        }
    }

    render() {

        const {getFieldDecorator} = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                md: {span: 6},
            },
            wrapperCol: {
                xs: {span: 24},
                md: {span: 12},
            },
        };

        const {dataSource, noteDataSource, vehicleDataSource} = this.state;
        const components = {
            body: {
                cell: EditableCell,
            },
        };
        const columns = this.columns.map(col => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    inputType: col.dataIndex === 'trailNo' ? 'auto' : 'text',
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: this.isEditing(record),
                }),
            };
        });
        const noteColumns = this.noteColumns.map(col => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    inputType: col.dataIndex === 'optDt' ? 'date2' : 'text',
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: this.isEditingNote(record),
                }),
            };
        });

        const vehicleColumns = this.vehicleColumns.map(col => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    inputType: (col.dataIndex === 'boxNo') ? 'select' : 'text',
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: this.isEditingVehicle(record),
                    boxNoData: this.state.boxNoData,
                }),
            };
        });
        const props = {
            name: 'file',
            showUploadList: false,
            action: baseUrl + '/api/v1/p/' + SYS + '/ktDeliveryImport?orderId=' + this.state.orderId,
            headers: {
                authorization: 'authorization-text',
            },
            onChange: (info) => {
                const fileList = [...info.fileList];
                fileList.map(file => {
                        if (info.file.uid == file.uid) {
                            if (file.response) {
                                this.getKtOrderDelivery(orderId)
                                if (file.response.code === 200) {
                                    message.success(`${info.file.name} 导入成功`);
                                } else if (file.response.code === 400) {
                                    message.error(`${info.file.name} 导入失败`);
                                    window.location.href = baseUrl + '/' + file.response.data;
                                } else {
                                    message.error(`${info.file.name} 导入失败，` + file.response.message)
                                }
                            }
                        }
                    }
                );
            }
        };
        return (
            <div className='info box-shadow padding-20'>
                <div className="head-title">
                    <span className='title'>物流详情</span>
                </div>
                <br/>
                <div className="info-detail">
                    <Row className='info-detail-item'>
                        <Col span={8}>
                            <span className='label'>订单编号 : </span>
                            <span>{this.state.orderNo}</span>
                        </Col>
                        <Col span={8}>
                            <span className='label'>起运地 : </span>
                            <span>{this.state.originAdd}</span>
                        </Col>
                        <Col span={8}>
                            <span className='label'>目的地 : </span>
                            <span>{this.state.destinaAdd}</span>
                        </Col>
                    </Row>
                    <Row className='info-detail-item'>
                        <Col span={8}>
                            <span className='label'>提交时间 : </span>
                            <span>{this.state.commitDt}</span>
                        </Col>
                        <Col span={8}>
                            <span className='label'>提货时间 : </span>
                            <span>{this.state.collectDt}</span>
                        </Col>
                        <Col span={8}>
                            <span className='label'>班列号 : </span>
                            <span><Input style={{width: 'auto'}} value={this.state.squadNumber} onChange={e => {
                                this.setState({
                                    squadNumber: e.target.value
                                })
                            }}/><Button type="primary" onClick={this.saveSquadNumber}>保存</Button></span>
                        </Col>
                    </Row>
                </div>
                <div className='info-item'>
                    <div className="info-item-title">
                        <div className='flex-between'>
                            <div>物流信息</div>
                            <div>
                                <AuthButton authority="delivery_edit:delivery_add" type='primary'
                                            style={{marginRight: '20px'}} onClick={() => {
                                    window.location.href = baseUrl.replace('/' + SYS, '/upload') + '/template/ktcrm物流信息模板.xlsx';
                                }}>模板下载</AuthButton>
                                <Upload {...props}>
                                    <AuthButton authority="delivery_edit:delivery_add" type='primary'
                                                style={{marginRight: '20px'}}>导入</AuthButton>
                                </Upload>
                                <AuthButton authority="delivery_edit:delivery_add" onClick={this.handleAdd}
                                            type='primary'>新增</AuthButton>
                            </div>
                        </div>
                    </div>
                    <div className="info-item-content">
                        <EditableContext.Provider value={this.props.form}>
                            <Table columns={columns}
                                   bordered
                                   components={components}
                                   rowClassName={() => 'editable-row'}
                                   pagination={{
                                       pageSize:PAGE_SIZE,
                                       showQuickJumper: true,
                                       onChange:(page, pageSize)=>{
                                           this.setState({
                                               wuliuPageNum:page
                                           })
                                       }
                                   }}
                                   dataSource={dataSource}
                                   size="middle"/>
                        </EditableContext.Provider>
                    </div>

                    <div className="info-item-title">
                        <div className='flex-between'>
                            <div>车辆信息</div>
                            <div><AuthButton authority="delivery_edit:car_add" onClick={this.handleAddVehicle}
                                             type='primary'>新增</AuthButton></div>
                        </div>
                    </div>
                    <div className="info-item-content">
                        <EditableContext.Provider value={this.props.form}>
                            <Table columns={vehicleColumns}
                                   components={components}
                                   scroll={{x: 'auto'}}
                                   bordered
                                   rowClassName={() => 'editable-row'}
                                   pagination={{
                                       onChange: (page2, pageSize2) => {
                                           this.setState({page2, pageSize2})
                                       }
                                   }
                                   }
                                   dataSource={vehicleDataSource}
                                   size="middle"/>
                        </EditableContext.Provider>
                    </div>

                    <div className="info-item-title">
                        <div className='flex-between'>
                            <div>备注信息</div>
                            {/*<div><AuthButton authority="delivery_edit:note_add" onClick={this.handleAddNote}*/}
                            {/*                 type='primary'>新增</AuthButton></div>*/}
                        </div>
                    </div>
                    <KtTrackLocTableForm orderId={this.state.orderId} readOnly={false} tabChange={this.tabChange}/>
                    {/*<div className="info-item-content">*/}
                    {/*    <EditableContext.Provider value={this.props.form}>*/}
                    {/*        <Table columns={noteColumns}*/}
                    {/*               components={components}*/}
                    {/*               scroll={{x: 'auto'}}*/}
                    {/*               bordered*/}
                    {/*               rowClassName={() => 'editable-row'}*/}
                    {/*               pagination={{*/}
                    {/*                   onChange: (page, pageSize) => {*/}
                    {/*                       this.setState({page, pageSize})*/}
                    {/*                   }*/}
                    {/*               }*/}
                    {/*               }*/}
                    {/*               dataSource={noteDataSource}*/}
                    {/*               size="middle"/>*/}
                    {/*    </EditableContext.Provider>*/}
                    {/*</div>*/}

                    <div className="info-item-title">
                        <div className='flex-between'>
                            <div>其他说明</div>
                        </div>
                    </div>
                    <div style={{marginTop: '20px'}}>
                        <Form >
                            <Form.Item label="其他说明" {...formItemLayout}>
                                {getFieldDecorator('otherExplain', {
                                    initialValue: this.state.otherExplain,
                                })(<TextArea style={{height: '100px', resize: 'none'}}/>)}
                            </Form.Item>
                        </Form>
                        <AuthButton type='primary' authority="delivery_edit:explain_save"
                                    onClick={this.handleSaveSubmit}
                                    style={{top: '-80px', left: '86%'}}>保存</AuthButton>
                    </div>

                    <div className="info-item-title">
                        轨迹信息
                    </div>
                    <div className="info-item-content">
                        <RouteStepViewForm nodes={this.state.orderNodes} routeType={this.state.routeType}
                                           readOnly={false} loading={this.state.loading} reload={()=>{this.getKtCabinShortFunc(this.state.orderId)}}/>
                    </div>
                    <div className="info-item-title">
                        轨迹展示
                    </div>
                    {
                        this.state.mapData ? <Tabs type="card" style={{marginTop: '10px'}} onChange={this.tabChange}
                                                   activeKey={this.state.currentTrailNo}>
                            {this.state.mapData.map(t => (
                                <TabPane tab={t.boxNo} key={t.trailNo} id={t.trailNo}>
                                </TabPane>
                            ))}
                        </Tabs> : null
                    }

                    <div className='track-map-box '>
                        <div className="track-step-map" id="bingmap">
                            <ReactBingmaps
                                //center = {[13.0827, 80.2707]}
                                zoom={8}
                                center={this.state.center}
                                bingmapKey={this.state.bingmapKey}
                                polyline={this.state.polyline}
                                infoboxesWithPushPins={this.state.infoboxesWithPushPins }
                            >
                            </ReactBingmaps>
                        </div>
                        <div className='track-map-list'>
                            {this.state.stepDescription ? <Timeline>
                                {this.state.stepDescription.map(des => (
                                    <Timeline.Item id={"step" + des.id} key={"step" + des.id}><p
                                        style={this.state.activeId === ("step" + des.id) ? {
                                            color: "#2975d5",
                                            paddingTop: 3
                                        } : (des.sts !== 'N' ? {
                                            color: "rgba(0, 0, 0, 0.9)",
                                            paddingTop: 3
                                        } : {color: "rgba(0,0,0,.45)", paddingTop: 3})}>{this.steDescription(des)}</p>
                                    </Timeline.Item>
                                ))}
                            </Timeline> : null}

                        </div>
                    </div>
                </div>
            </div>

        )
    }
}
export default Form.create()(TrackInfo);